import { useState, useEffect } from "react";
import { getUserData } from "../../utils/api/getUserData.js";
import { updatePreferences } from "../../utils/api/updatePreferences.js";

export function ProfilePage5(user) {

  const [userData, setUserData] = useState({
    newsletterFlag:  false,
    blogNl:          false,
    weeklyNl:        false,
    specialOfferNl:  false,
  })

  useEffect(() => {
    // cargar datos de usuario
    loadUserData();
  }, []);

  const loadUserData = async () => {
    const loadedUserData = await getUserData(user);

    console.log(loadedUserData.data)
    setUserData((prevUser) => ({
      ...prevUser,  
      newsletterFlag:  loadedUserData.data.newsletter_flag,
      blogNl:          loadedUserData.data.blog_nl,
      weeklyNl:        loadedUserData.data.weekly_nl,
      specialOfferNl: loadedUserData.data.special_offer_nl
    }));
  }

  const handleEditPreferences = async () => {
    const response = await updatePreferences(user, userData);
    if(response){

    }
  }
 
  return (
    <>

      <div className="m-layMiCuenta__body">
        <div className="bx">
          <header>
            <br/>
            <span className="ht-body-bold uppercase" >Mis preferencias</span><br/>
            <span className="ht-body-regular">Revisa y edita tus preferencias</span>
          </header>


                        
                        <div className="m-frmGroup">
                            <div className="chRad">
                                <input className="checkbox" type="checkbox" checked={userData.newsletterFlag} />
                                <span>Enviarme notificaciones por correo electrónico</span>
                            </div>
                        </div>
                        <div className="m-frmGroup">
                            <div className="chRad">
                                <input className="checkbox" type="checkbox" checked={userData.specialOfferNl}/>
                                <span>Ofertas especiales por temporada</span>
                            </div>
                        </div>
                        <div className="m-frmGroup">
                            <div className="chRad">
                                <input className="" type="checkbox" checked={userData.blogNl}/>
                                <span>Enviarme notificaciones por correo electrónico cuando haya nuevas entradas en el blog</span>
                            </div>
                        </div>
                        <div className="m-frmGroup is-error">
                            <div className="chRad">
                                <input className="checkbox" type="checkbox" checked={userData.weeklyNl}/>
                                <span>Acepto la newsletter promocional semanal</span>
                            </div>
                           
                        </div>
                        <div className="separator"></div>
                        <button className="btnOrange-l" onClick={() => handleEditPreferences()}>Guardar</button>
        </div>
      </div>
    </>
  )
}